enum TrackConstants {
  GET_TRACKS_LIST = "GET_TRACKS_LIST",
  GET_TRACKS_LIST_SUCCESS = "GET_TRACKS_LIST_SUCCESS",
  GET_TRACKS_LIST_FAILURE = "GET_TRACKS_LIST_FAILURE",

  GET_ALL_TRACKS_REQUEST = "GET_ALL_TRACKS_REQUEST",
  GET_ALL_TRACKS_SUCCESS = "GET_ALL_TRACKS_SUCCESS",
  GET_ALL_TRACKS_FAILURE = "GET_ALL_TRACKS_FAILURE",

  GET_TRACKS_INCOME_SUMMARY_REQUEST = "GET_TRACKS_INCOME_SUMMARY_REQUEST",
  GET_TRACKS_INCOME_SUMMARY_SUCCESS = "GET_TRACKS_INCOME_SUMMARY_SUCCESS",
  GET_TRACKS_INCOME_SUMMARY_FAILURE = "GET_TRACKS_INCOME_SUMMARY_FAILURE",

  CREATE_TRACK_REQUEST = "CREATE_TRACK_REQUEST",
  CREATE_TRACK_SUCCESS = "CREATE_TRACK_SUCCESS",
  CREATE_TRACK_FAILURE = "CREATE_TRACK_FAILURE",

  EDIT_TRACK_REQUEST = "EDIT_TRACK_REQUEST",
  EDIT_TRACK_SUCCESS = "EDIT_TRACK_SUCCESS",
  EDIT_TRACK_FAILURE = "EDIT_TRACK_FAILURE",

  DELETE_TRACK_REQUEST = "DELETE_TRACK_REQUEST",
  DELETE_TRACK_SUCCESS = "DELETE_TRACK_SUCCESS",
  DELETE_TRACK_FAILURE = "DELETE_TRACK_FAILURE",

  DOWNLOAD_TRACKS_IN_CSV_REQUEST = "DOWNLOAD_TRACKS_IN_CSV_REQUEST",
  DOWNLOAD_TRACKS_IN_CSV_SUCCESS = "DOWNLOAD_TRACKS_IN_CSV_SUCCESS",
  DOWNLOAD_TRACKS_IN_CSV_FAILURE = "DOWNLOAD_TRACKS_IN_CSV_FAILURE",

  RESET_TRACKS = "RESET_TRACKS",
  RESET_DOWNLOAD_TRACKS_IN_CSV = "RESET_DOWNLOAD_TRACKS_IN_CSV",
}

export default TrackConstants;
